<template>
  <b-row>
    <div v-if="loading" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
    </div>
    <div class="d-flex mb-1 w-100 p-1">
      <div class="d-flex flex-column w-100">
        <div class="d-flex flex-row justify-content-between w-100 mb-2">
          <div class="flex-column mx-1">
            <div class="flex-row">
              <label class="d-inline-block text-sm-left mr-50 mb-1">{{ $t('Per page') }}</label>
            </div>
            <div class="flex-row">
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-100" />
            </div>
          </div>
          <div class="d-flex flex-column mx-2 justify-content-center align-items-center" v-if="exportables.length > 0">
            <b-dropdown :text="$t('Export')" offset="25" variant="primary" class="mx-1">
              <b-dropdown-item v-for="exportable in exportables" :key="exportable.label" class="text-center"
                @click.prevent="() => {
                  downloadData(exportable.export, exportable.exporter, exportable.params)
                }">
                {{ $t(exportable.label) }}
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="d-flex flex-column mx-2 justify-content-center align-items-center">
            <div class="d-flex flex-row">
              <div class="flex-column">
                <b-form-input id="filterInput" v-model="filter" type="search" :placeholder=searchPlaceHolder />
              </div>
              <div class="flex-column mx-1">
                <b-button :disabled="!filter" @click="filter = ''">
                  {{ $t('Clear') }}
                </b-button>
              </div>
            </div>

          </div>
        </div>
        <div class="d-flex flex-row justify-content-center w-100">
          <b-table small striped hover responsive :per-page="perPage" :current-page="currentPage" :items="items"
            :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
            :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" show-empty
            :empty-text="$t('There are no records to show')"
            class="text-center">
            <template #cell()="data">
              <div class="col-value rounded p-1"
                @click="() => $emit('onRowClick', { item: data.item, index: data.index, field: data.field })">
                {{ data.item[data.field.key] }}
              </div>
            </template>
          </b-table>
        </div>

        <div class="d-flex flex-row justify-content-center w-100 my-1">
          <span class="text-muted">{{ $t('Showing') }} {{ ((currentPage - 1) * perPage) + 1 }} {{ $t('to') }} {{
            Math.min(currentPage * perPage, items.length) }} {{ $t('of') }} {{ items.length }}
            {{ $t('entries') }}</span>
        </div>

        <div class="d-flex flex-row justify-content-center w-100 mt-2">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" size="sm" class="my-0" />
        </div>
      </div>

    </div>



    <b-col cols="12">

    </b-col>

    <b-col cols="12">

    </b-col>
  </b-row>
</template>

<script>
import axios from '@/libs/axios'
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BDropdown,
  BDropdownItem
} from 'bootstrap-vue'
import { OrbitSpinner } from 'epic-spinners'
import moment from 'moment'

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    OrbitSpinner
  },
  props: ['items', 'fields', 'exportables'],
  emits: ['onRowClick'],
  data() {
    return {
      filterLabel: this.$t('Filter'),
      searchPlaceHolder: this.$t('Type to Search'),
      perPage: 10,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      loading: false
    }
  },
  watch: {
    items(newItems, oldItems) {
      this.totalRows = newItems.length
      this.filter = null
    }
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: this.f.label, value: f.key }))
    },
  },
  mounted() {
    this.totalRows = this.items.length
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    exportData(exportType, exporter, params) {
      return new Promise((resolve, reject) => {
        axios.post('export', { export: exportType, exporter, ...params }, { responseType: 'blob' })
          .then(res => {
            resolve(new Blob([res.data], { type: res.headers['content-type'], encoding: 'UTF-8' }))
          })
          .catch(err => reject(err))
      })
    },
    downloadData(exportType, exporter, params) {
      this.loading = true
      this.exportData(exportType, exporter, params)
        .then((blob) => {
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'file-' + moment().format('YYYY-MM-DD HH:mm:ss') + '.' + exporter
          link.click()
        }).finally(() => this.loading = false)
    }
  },
}
</script>

<style scoped>
.col-value:hover {
  background-color: white;
}
</style>